import React from 'react'
import { EnvelopeSimpleOpen, Eye, EyeClosed, LockKey } from '@phosphor-icons/react'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { Link } from 'react-router-dom'
import TimedToastAlert from '../../components/alerts/TimedToastAlert'
import { LOGIN_FIELD_SX } from './loginConstants'

export default function LoginForm({
  email,
  setEmail,
  password,
  setPassword,
  showPassword,
  setShowPassword,
  isSubmitting,
  onSubmit,
  emailError = '',
  passwordError = '',
  formAlertId,
  formAlertSeverity = 'error',
  formAlertMessage,
  onClearFormAlert,
  fieldSx = LOGIN_FIELD_SX
}) {
  return (
    <>
      <form className="login-main-form" onSubmit={onSubmit} noValidate>
        <TextField
          id="login-email"
          label="Correo electrónico"
          variant="outlined"
          fullWidth
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          required
          error={Boolean(emailError)}
          helperText={emailError || undefined}
          sx={fieldSx}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <EnvelopeSimpleOpen className="login-field-icon" size={18} />
                </InputAdornment>
              )
            }
          }}
        />

        <TextField
          id="login-password"
          label="Contraseña"
          variant="outlined"
          fullWidth
          type={showPassword ? 'text' : 'password'}
          name="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
          error={Boolean(passwordError)}
          helperText={passwordError || undefined}
          sx={fieldSx}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <LockKey className="login-field-icon" size={18} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    edge="end"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <Eye className="login-field-icon" size={18} />
                    ) : (
                      <EyeClosed className="login-field-icon" size={18} />
                    )}
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
        />

        {formAlertMessage ? (
          <div className="login-form-alert" aria-live="polite">
            <TimedToastAlert
              id={formAlertId}
              variant="inline"
              severity={formAlertSeverity}
              message={formAlertMessage}
              onClose={onClearFormAlert}
            />
          </div>
        ) : null}

        <button
          className={`login-submit-btn${isSubmitting ? ' is-loading' : ''}`}
          type="submit"
          disabled={isSubmitting}
        >
          <span className="login-submit-label">Iniciar sesión</span>
          <span className="login-submit-spinner" aria-hidden="true" />
        </button>
      </form>

      <p className="login-form-footer">
        <Link className="login-forgot-link" to="/cambiar-contrasena">
          ¿Olvidaste tu contraseña?
        </Link>
      </p>
    </>
  )
}
